import { LOYALTY_REWARDS_STORAGE_PREFIX } from 'loyalty/storage/loyaltyRewardsNotification'

// Shares the logout-cleanup prefix
const TIER_UPGRADE_CLAIMED_KEY = `${LOYALTY_REWARDS_STORAGE_PREFIX}tier-upgrade-claimed`

/** Tells the customer's other open tabs that a tier upgrade campaign was just claimed in this one. */
export function broadcastTierUpgradeClaimed(campaignId: string): void {
  try {
    window.localStorage.setItem(TIER_UPGRADE_CLAIMED_KEY, JSON.stringify({ campaignId, at: Date.now() }))
  } catch {
    // Storage can be unavailable (privacy modes); other tabs then update on their next reload
  }
}

/**
 * Calls `onClaimed` with the campaign ID when another tab claims a tier upgrade campaign. `storage`
 * events only fire in tabs other than the one that wrote the value. Returns an unsubscribe function.
 */
export function onTierUpgradeClaimedInAnotherTab(onClaimed: (campaignId: string) => void): () => void {
  const onStorage = (event: StorageEvent) => {
    if (event.key !== TIER_UPGRADE_CLAIMED_KEY || !event.newValue) return
    try {
      const { campaignId } = JSON.parse(event.newValue)
      if (typeof campaignId === 'string') onClaimed(campaignId)
    } catch {}
  }
  window.addEventListener('storage', onStorage)
  return () => window.removeEventListener('storage', onStorage)
}
